import { render, staticRenderFns } from "./FeatureForm.vue?vue&type=template&id=00b1198e&scoped=true"
import script from "./FeatureForm.vue?vue&type=script&lang=js"
export * from "./FeatureForm.vue?vue&type=script&lang=js"
import style0 from "./FeatureForm.vue?vue&type=style&index=0&id=00b1198e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1198e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextField,VTextarea})
